<template>
  <LabelledInput>
    <b-checkbox
      :checked="rotateGraph"
      @input="$emit('update:rotateGraph', $event)"
    >
      Rotate Bar Graph
    </b-checkbox>

    <b-checkbox
      :checked="showXAxis"
      @input="$emit('update:showXAxis', $event)"
    >
      {{ rotateGraph ? 'Y Axis' : 'X Axis' }}
    </b-checkbox>

    <b-checkbox
      :checked="showYAxis"
      @input="$emit('update:showYAxis', $event)"
    >
      {{ rotateGraph ? 'X Axis' : 'Y Axis' }}
    </b-checkbox>

    <b-checkbox
      :checked="showLegend"
      @input="$emit('update:showLegend', $event)"
    >
      Legend
    </b-checkbox>
  </LabelledInput>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'

const components = {
  LabelledInput,
}

const props = {
  rotateGraph: Boolean,
  showXAxis: Boolean,
  showYAxis: Boolean,
  showLegend: Boolean,
}

@Component({ components })
export default class GraphSettings extends Vue.extend({ props }) {}

</script>
